// extracted by css-extract-rspack-plugin
export default {"root":"organisation-area-settings-popover-content_root__hFLaL"};